module.exports = __webpack_public_path__ + "static/media/pmv_gray_circle.f0089691.svg";